'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasds';
var iconName = 'star-half-stroke';
var width = 576;
var height = 512;
var aliases = ["star-half-alt"];
var unicode = 'f5c0';
var svgPathData = ['M288.2-52.8l0 140.8c27.2 53.2 44 86.1 50.4 98.7 13.9 2.2 50.4 8 109.4 17.4-42.2 42.3-68.3 68.4-78.3 78.4 2.2 13.9 7.9 50.4 17.3 109.4-53.3-27.1-86.2-43.8-98.7-50.2l0 71.8c80.8 41.1 141.3 71.9 181.5 92.3-7-44.5-17.6-111.6-31.7-201.2 64.1-64.2 112-112.2 143.9-144.1-44.5-7.1-111.6-17.7-201.1-32-41.2-80.8-72.1-141.2-92.6-181.4z', 'M288.2-52.8l0 466.3-181.5 92.3 31.7-201.2-143.9-144.1 201.1-32 92.6-181.4z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faStarHalfStroke = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;